import { render, staticRenderFns } from "./DynamicFile.vue?vue&type=template&id=59ab1f10&scoped=true&"
import script from "./DynamicFile.vue?vue&type=script&lang=js&"
export * from "./DynamicFile.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFile.vue?vue&type=style&index=0&id=59ab1f10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ab1f10",
  null
  
)

export default component.exports